export const TrashIcon = ({
  width = 20,
  height = 20,
  className,
  title = "Trash",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.041 16.6337C15.3687 16.1839 15.5049 15.6546 15.5341 15.2964L16.2049 1.06633H16.9568C17.2513 1.06633 17.49 0.827627 17.49 0.533167C17.49 0.238707 17.2513 0 16.9568 0H0.533168C0.238708 0 0 0.238707 0 0.533167C0 0.827627 0.238707 1.06633 0.533167 1.06633H1.17087L1.84104 15.2878L1.84213 15.3012C1.8714 15.6594 2.00699 16.1839 2.33477 16.6337C2.67796 17.1046 3.23393 17.49 4.03922 17.49H13.3365C14.1418 17.49 14.6978 17.1046 15.041 16.6337ZM2.90563 15.2227L2.23838 1.06633H15.1374L14.4701 15.2226C14.4515 15.4313 14.3648 15.751 14.1792 16.0057C14.0067 16.2424 13.7531 16.4237 13.3365 16.4237H4.03922C3.62264 16.4237 3.36902 16.2424 3.19655 16.0057C3.01097 15.751 2.92424 15.4313 2.90563 15.2227Z"
        fill="currentColor"
      />
    </svg>
  );
};
